import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as shiftAction from '../actions/shift.action';
import * as freelancerAction from '../../../freelancers/store/actions/freelancer.action';
import {switchMap, catchError, mergeMap, withLatestFrom, filter, tap, map} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {ShiftsService} from '../../shifts.service';


@Injectable()
export class ShiftEffect {

  constructor(private actions: Actions, private shiftService: ShiftsService, private store: Store<fromStore.AppState>) {
  }

  @Effect()
  rotateShift: Observable<Action> = this.actions.ofType(shiftAction.ROTATE_SHIFT)
    .pipe(
      map((action: shiftAction.RotateShift) => action.payload),
      mergeMap(shiftId => {
        return this.shiftService.rotateShift(shiftId)
          .map(r => new shiftAction.RotateShiftSuccess(r))
          .catch(e => of(new shiftAction.RotateShiftError(e)));
      })
    );

  @Effect()
  getAllShifts: Observable<Action> = this.actions.ofType(shiftAction.GET_ALL_SHIFTS)
    .pipe(
      switchMap(() => {
        this.store.dispatch(new freelancerAction.GetAllFreelancers());
        return this.shiftService.getAllShifts()
          .map(res => {
            res.forEach(shift => this.shiftModded(shift));
            return new shiftAction.GetAllShiftsSuccess(res);
          })
          .catch(error => of(new shiftAction.GetAllShiftsError(error)));
      })
    );


  @Effect()
  getShift: Observable<Action> = this.actions.ofType(shiftAction.GET_SHIFT)
    .pipe(
      withLatestFrom(
        // select shifts.
        this.store.select(state => state.shiftsFeature.shifts.entities),
        (action: any, shifts) => {
          // if no shifts present, proceed for API.
          if (isNullOrUndefined(shifts)) {
            return action;
          } else {
            // shifts exists in store.
            const shift = shifts.filter(b => b.id === action.payload)[0];
            if (!!shift) {
              // if required shift is present in store, then return;
              return undefined;
            } else {
              // if required shifts not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.shiftService.getShift(action.payload)
          .map(res => new shiftAction.GetShiftSuccess(this.shiftModded(res)))
          .catch(error => of(new shiftAction.GetShiftError(error)));
      })
    );

  private shiftModded(shift) {
    shift.moddedBooked = [];
    shift.moddedRequested = [];
    shift.moddedHold = [];
    shift.moddedCase = [];
    if (shift.bookedFreelancers) {
      shift.bookedFreelancers.forEach(freelancerId => {
        this.store.select(state => state.freelancersFeature.freelancers.users).subscribe(users => {
          shift.moddedBooked.push(users.filter(user => user.id === freelancerId)[0]);
        });
      });
    }
    if (shift.requestedFreelancers) {
      shift.requestedFreelancers.forEach(freelancerId => {
        this.store.select(state => state.freelancersFeature.freelancers.users).subscribe(users => {
          shift.moddedRequested.push(users.filter(user => user.id === freelancerId)[0]);
        });
      });
    }
    if (shift.onHold) {
      shift.onHold.forEach(freelancerId => {
        this.store.select(state => state.freelancersFeature.freelancers.users).subscribe(users => {
          shift.moddedHold.push(users.filter(user => user.id === freelancerId)[0]);
        });
      });
    }
    if (shift.inCase) {
      shift.inCase.forEach(freelancerId => {
        this.store.select(state => state.freelancersFeature.freelancers.users).subscribe(users => {
          shift.moddedCase.push(users.filter(user => user.id === freelancerId)[0]);
        });
      });
    }
    return shift;
  }
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/effects/shift.effect.ts